(function($, undefined) {
	/*
	 * Mathilde Paccoud
	 * Last update 25/03/2017
	 * 
	 * Purpose : Allows to store a session variable
	 * 
	 * @param : key - unique key to store a value in
	 * @param : val - value to store in the label; if val is null : session variable is deleted
	 * @param : callback - any function to be called once value is stored
	 * 
	 * Call : var session = Fw.component.models().session;
	 */
	'use strict';
	
	var save = function(key,val,callback){
		if(val === null){
			ajax("/action/sessionVariables?key=" + key, callback, true);			
		}else{			
			ajax("/action/sessionVariables?key=" + key + "&value=" + val, callback, true);
		}
	};
	
	var init = function (page) {
		var currPage = $(page);	  
	};
		
	var session = Fw.component.export('session', {
		init: init,
		save: save
	});
	
	$(window).on("load",function(){
		init();
	});
	
})(jQuery);